<template>
    <div class="Home">
        <div class="container-fluid">
            <div class="row">
                <div class="col center-text">
                    <h1>{{ WelcomeLabel }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <b-card title="Outlook Connection Status:" align="center" class="fill-row">
                        <GraphConnector />
                    </b-card>
                </div>
                <div class="col-lg-8">
                    <b-card title="Appointments Needing Documentation:" align="center" class="fill-row">
                        <h1>{{ AppointmentsNeedingDocumentation }} <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="GetAppointmentsNeedingDocumentationItemization()" class="olive-green-text pointer" /></h1>
                        <div style="max-height: 250px; overflow-y: auto; text-align:left;">
                            <p v-for="appt in AppointmentsNeedingDocumentationItemization">
                                <span class="bold">{{appt.ClientSubProgramMembership.Client.Person.FullName}}</span>: {{appt.AppointmentType.Label}} ({{appt.AppointmentStatus}}) on {{formatDate(appt.StartDateTime)}} {{appt.CurrentDocumentStatus == "Draft" ? "[PROGRAM DOC NEEDED]" : ""}} {{appt.CurrentMHDocumentStatus == "Draft" ? "[MH DOC NEEDED]" : ""}}
                            </p>
                        </div>

                    </b-card>
                </div>
                <div class="col-lg-4">
                    <b-card title="My Reports" class="fill-row">
                        
                        <ReportDownloader report-label="My Productivity Data"
                                          endpoint="MentalHealth/Billing/Reports/GetProviderHoursAndOnTime"
                                          :parameter-schema="ParamsMyProductivity"
                                          report-description="Provides a list of Welligent notes that you have completed, with their completion date, due date, and whether or not the note was written on time.  Summary report split by assigned supervisor.  NOTE:  Anything done in Welligent takes up to 2 hours to appear here in OLIVER." />
                    </b-card>
                </div>
                <div class="col-lg-4">
                    <b-card title="Need Help?" align="center" class="fill-row">
                        <p><font-awesome-icon :icon="['fa', 'envelope']" /> <a href="https://helpdesk.olivecrest.org">helpdesk.olivecrest.org</a></p>
                        <p><font-awesome-icon :icon="['fa', 'phone-volume']" /> x8020</p>
                    </b-card>
                </div>
            </div>
            <div class="row" style="margin-top: 20px;" v-if="CheckPermission('Measures.Download')">
                <div class="col">
                    <b-card title="Paper Packet Downloads" align="center" class="fill-row">
                        <div class="row" style="text-align: left;">
                            <div class="col-lg-4">
                                <h4 class="underline">Intake:</h4>
                                <p> <span class="bold">1st F2F Packet (Checklist, Consents, etc.):</span> <span @click="DownloadFile('FirstF2FPacket_English.pdf','52113533-be05-44d1-a905-dc5ceabc8cde')" class="link-like">English</span> </p>
                                <p> <span class="bold">Intake Measures Packet:</span> <span @click="DownloadFile('IntakeMeasures_English.pdf','72917fbd-e5a9-48c5-854e-88f40d5903c8')" class="link-like">English</span> <span @click="DownloadFile('IntakeMeasures_Spanish.pdf','4a95e108-c06a-4f50-ab8c-14b64959db87')" class="link-like">Spanish</span> </p>
                            </div>
                            <div class="col-lg-4">
                                <h4 class="underline">Discharge:</h4>
                                <p> <span class="bold">Discharge Measures Packet:</span> <span @click="DownloadFile('DischargeMeasures_English.pdf','5ce65fd9-72b9-40a3-b16b-bbf1596a55f5')" class="link-like">English</span> <span @click="DownloadFile('DischargeMeasures_Spanish.pdf','5a0a2d16-c70d-4a6a-9b10-b9434b1d6260')" class="link-like">Spanish</span> </p>
                            </div>
                            <div class="col-lg-4">
                                <h4 class="underline">Sampling Measures:</h4>
                                <p> <span class="bold">WFI-EZ:</span> <span @click="DownloadFile('WFI-EZ_English.pdf','1ab0be1f-519e-496f-9aa2-7d6d49222d57')" class="link-like">English</span> <span @click="DownloadFile('WFI-EZ_Spanish.pdf','0b8ca429-edb1-4baf-aa70-c33352e1dc8c')" class="link-like">Spanish</span> </p>
                                <p> <span class="bold">TOM Scoresheet:</span> <span @click="DownloadFile('TOMScoresheet.pdf','c667ec18-f120-4d53-a466-ffa1da88e0f3')" class="link-like">English</span> </p>
                            </div>

                        </div>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
    library.add(faPhoneVolume);
    import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
    library.add(faEnvelope);
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);

    import GraphConnector from './GraphConnector.vue';
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';
    import { EventBus } from '../../../services/event-bus.js';

    export default {
        created() {
 
        },
        props: [],
        data: function () {
            return {
                AppointmentsNeedingDocumentation: "Checking...",
                AppointmentsNeedingDocumentationItemization: [],
                HelpVideos: [
                    {
                        GroupName: "Everyone",
                        Topics: [
                            {
                                Name: "Overview",
                                URL: "/videos/overview.mp4"
                            },
                            {
                                Name: "The Service Log",
                                URL: "/videos/servicelog.mp4"
                            },
                            {
                                Name: "Appointment Scheduling",
                                URL: "/videos/appointmentscheduling.mp4"
                            }
                        ]
                    }
                ],
                ParamsMyServiceList: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Employee:",
                        Name: "MyAppointmentsOnly",
                        Type: "HiddenConstant",
                        Value: true,
                        DisplayValue: "Me"
                    },
                ],
                ParamsMyProductivity: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Employee:",
                        Name: "MyAppointmentsOnly",
                        Type: "HiddenConstant",
                        Value: true,
                        DisplayValue: "Me"
                    },
                ],
            };
        },
        methods: {
            GetAppointmentsNeedingDocumentationItemization() {
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/ClientAppointments/GetAppointmentsNeedingDocumentationItemization", {}, this.GetAppointmentsNeedingDocumentationItemizationsSuccess, () => { }, true);
            },
            GetAppointmentsNeedingDocumentationItemizationsSuccess(response) {
                this.AppointmentsNeedingDocumentation = response.data.data.Count;
                this.AppointmentsNeedingDocumentationItemization = response.data.data.Itemization;
            },
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            DownloadFile(fileName, fileID) {
                this.$MasterAPI.ExecuteFileRequest("Core/Files/GetFileContent/" + fileName, { FileId: fileID });
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            GraphConnector,
            ReportDownloader
        },
        computed: {
            WelcomeLabel: function () {
                let name = this.$store.state.User.PrivateProfile.FirstName;
                let hour = moment().hours();
                let timeOfDay = "Hello"
                if (hour < 3) {
                    timeOfDay = "Good Evening";
                } else if (hour < 12) {
                    timeOfDay = "Good Morning";
                } else if (hour < 18) {
                    timeOfDay = "Good Afternoon";
                } else {
                    timeOfDay = "Good Evening";
                }
                return timeOfDay + " " + name + "!";
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
        },
        mounted() {
            this.GetAppointmentsNeedingDocumentationItemization();
            this.ParamsMyServiceList[0].Options = this.SubProgramOptions;
        }
    }
</script>

<style scoped>
</style>